/**
 * @generated SignedSource<<d3a1bd7ad090cb61357d8b14795fb768>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileSummaryNewPane_transaction$data = {
  readonly buyerChargeCurrency: Currency | null;
  readonly isNegotiable: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDutiesMessage_transaction" | "CheckoutMobilePromotion_transaction" | "CheckoutMobileSummaryNewPaneTitle_transaction" | "CheckoutMobileSummaryPriceTable_transaction" | "CheckoutSummaryItemSkuDetails_transaction" | "CheckoutTotalsDutiesMessage_transaction">;
  readonly " $fragmentType": "CheckoutMobileSummaryNewPane_transaction";
};
export type CheckoutMobileSummaryNewPane_transaction$key = {
  readonly " $data"?: CheckoutMobileSummaryNewPane_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryNewPane_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileSummaryNewPane_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryNewPaneTitle_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSummaryItemSkuDetails_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryPriceTable_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobilePromotion_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDutiesMessage_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTotalsDutiesMessage_transaction"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "buyerChargeCurrency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNegotiable",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "0803899e08dc8948f9b35ccff4a736c4";

export default node;
